import { Component } from '@theme/component';
import { getWishlist, WishlistUpdateEvent } from '@theme/wishlist';

/**
 * Header wishlist icon: shows a count bubble that stays in sync with the theme-native wishlist
 * store, the same way `cart-icon` tracks the cart.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} bubble
 * @property {HTMLElement} bubbleCount
 *
 * @extends {Component<Refs>}
 */
class WishlistIcon extends Component {
  requiredRefs = ['bubble', 'bubbleCount'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(WishlistUpdateEvent.eventName, this.onUpdate);
    this.renderCount(getWishlist().length);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(WishlistUpdateEvent.eventName, this.onUpdate);
  }

  /**
   * @param {WishlistUpdateEvent} event
   */
  onUpdate = (event) => {
    this.renderCount(event.detail.handles.length);
  };

  /**
   * @param {number} count
   */
  renderCount(count) {
    this.refs.bubbleCount.textContent = count > 0 ? String(count) : '';
    this.refs.bubble.classList.toggle('visually-hidden', count === 0);
    this.classList.toggle('header-actions__wishlist-icon--has-items', count > 0);
  }
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
